import "../../assets/scss/privacy-style.scss";
import React from "react";
import { useTranslation } from "react-i18next";

const Privacy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="privacy">
      <div>
        <h2>{t("Privacy Policy")}</h2>
        <p>{t("privacy.lastUpdated")}</p>
      </div>

      <section>
        <h2>{t("privacy.section1.title")}</h2>
        <p>{t("privacy.section1.body")}</p>
      </section>

      <section>
        <h2>{t("privacy.section2.title")}</h2>
        <ul>
          <li>
            <strong>{t("privacy.section2.item1.label")}</strong>{" "}
            {t("privacy.section2.item1.desc")}
          </li>
          <li>
            <strong>{t("privacy.section2.item2.label")}</strong>{" "}
            {t("privacy.section2.item2.desc")}
          </li>
          <li>
            <strong>{t("privacy.section2.item3.label")}</strong>{" "}
            {t("privacy.section2.item3.desc")}
          </li>
        </ul>
      </section>

      <section>
        <h2>{t("privacy.section3.title")}</h2>
        <ul>
          <li>{t("privacy.section3.item1")}</li>
          <li>{t("privacy.section3.item2")}</li>
          <li>{t("privacy.section3.item3")}</li>
          <li>{t("privacy.section3.item4")}</li>
          <li>{t("privacy.section3.item5")}</li>
        </ul>
      </section>

      <section>
        <h2>{t("privacy.section4.title")}</h2>
        <p>{t("privacy.section4.body")}</p>
      </section>

      <section>
        <h2>{t("privacy.section5.title")}</h2>
        <p>{t("privacy.section5.body")}</p>
      </section>

      <section>
        <h2>{t("privacy.section6.title")}</h2>
        <p>{t("privacy.section6.body")}</p>
      </section>

      <section>
        <h2>{t("privacy.section7.title")}</h2>
        <p>{t("privacy.section7.body")}</p>
      </section>

      <section>
        <h2>{t("privacy.section8.title")}</h2>
        <p>
          {t("privacy.section8.body")}{" "}
          <a href="mailto:info@neurowatt.ai">info@neurowatt.ai</a>
        </p>
      </section>
    </div>
  );
};

export default Privacy;
